import { useCallback, useMemo, useState } from 'react'
import { useGetBrandImages } from '../../../../../api/media'

export const useBrandImageManager = (form) => {
  const [selectedFormField, setSelectedFormField] = useState(null)
  const [openAddImageModal, setOpenAddImageModal] = useState(false)
  const [viewImageListModal, setViewImageListModal] = useState(false)
  const [selectedImage, setSelectedImage] = useState(null)

  const { data: images, isLoading: imagesLoading } = useGetBrandImages({}, {
    enabled: viewImageListModal
  })

  const mappedImages = useMemo(() => {
    if (!images?.data) return images
    return {
      ...images,
      data: images.data.map(img => ({ ...img, thumbnailUrl: img.imageUrl }))
    }
  }, [images])

  const openAddModal = useCallback((field) => {
    setSelectedFormField(field)
    setOpenAddImageModal(true)
  }, [])

  const closeAddModal = useCallback(() => {
    setOpenAddImageModal(false)
  }, [])

  const setImageUrlField = useCallback((result) => {
    form.setValue(selectedFormField, result?.image?.imageUrl || '')
    form.trigger(selectedFormField)
    setOpenAddImageModal(false)
  }, [form, selectedFormField])

  const handleSelectedImage = useCallback((image) => {
    setSelectedImage(image)
    form.setValue(selectedFormField, image.imageUrl)
    form.trigger(selectedFormField)
    setSelectedFormField(null)
    setViewImageListModal(false)
  }, [form, selectedFormField])

  const handleShowImageList = useCallback((field) => {
    setSelectedFormField(field)
    setViewImageListModal(true)
  }, [])

  const closeImageListModal = useCallback(() => {
    setViewImageListModal(false)
  }, [])

  const imageModalProps = useMemo(() => ({
    viewImageListModal,
    onCloseImageList: closeImageListModal,
    images: mappedImages,
    imagesLoading,
    selectedImage,
    onSelectImage: handleSelectedImage,
    openAddImageModal,
    onCompleteAddImage: setImageUrlField,
    onCloseAddImage: closeAddModal
  }), [
    viewImageListModal,
    mappedImages,
    imagesLoading,
    selectedImage,
    handleSelectedImage,
    openAddImageModal,
    setImageUrlField,
    closeAddModal,
    closeImageListModal
  ])

  return { openAddModal, handleShowImageList, imageModalProps }
}
